// extracted by mini-css-extract-plugin
module.exports = {"Card":"card_Card__2UpeN","cardImage":"card_cardImage__1hmRk","cardTitle":"card_cardTitle__1ToM2","cardClassification":"card_cardClassification__IWS9o"};